module.exports = __webpack_public_path__ + "img/text-cup.30cc97f4.png";